class CartProgressBar extends HTMLElement {
    constructor() {
      super();
      this.onCartUpdate = this.onCartUpdate.bind(this);
    }
  
    connectedCallback() {
      this.shippingThreshold = parseInt(this.dataset.shippingThreshold || '5000', 10);
      this.giftThreshold = parseInt(this.dataset.giftThreshold || '15000', 10);
      this.giftVariantId = this.dataset.giftVariantId;
      this.currencySymbol = this.dataset.currencySymbol || '€';

      this.render();
  
      const initialTotal = parseInt(this.dataset.cartTotal || '0', 10);
      this.updateProgress(initialTotal);

      document.addEventListener('cart:updated', this.onCartUpdate);
      document.addEventListener('cart:refresh', this.onCartUpdate);

      const obj = this;
    }
  
    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdate);
      document.removeEventListener('cart:refresh', this.onCartUpdate);
      if (this.unsubscribe) this.unsubscribe();
    }

    async verifyGiftItem() {
        const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const res = await fetch(rootUrl + 'cart.js');
        if (!res.ok) return;
    
        const cart = await res.json();
        if (!cart || !cart.items || cart.items.length === 0) return;

        const giftItem = cart.items.find(item => {
            const isGiftProperty = item?.properties["_is_free_gift"] === "true";
            const isVariantEquals = (item.variant_id + "") === this.giftVariantId ? true : false;

            return  isGiftProperty && isVariantEquals;
        });
        const cartTotalWithoutGift = giftItem ? cart.total_price - giftItem.final_line_price : cart.total_price;

        if (cartTotalWithoutGift >= this.giftThreshold && !giftItem) {
            await this.addGift(this.giftVariantId);
        } else if (cartTotalWithoutGift < this.giftThreshold && giftItem) {
            await this.removeGift(giftItem.key);
        }
    }
  
    onCartUpdate(event) {
        console.log(event)
      const total = event.detail?.cart?.total_price ?? event.detail?.total_price;
      if (total !== undefined) {
        this.updateProgress(total);
      }

      console.log(event)
    }
  
    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return `${this.currencySymbol}${amount}`;
    }

    async addGift(giftVariantId) {
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: giftVariantId,
                quantity: 1,
                properties: { '_is_free_gift': 'true' }
              }]
            })
          });
        } catch (error) {
          console.error('CartProgressBar: Failed to add gift', error);
        }
    }
    
    async removeGift(lineItemKey) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: lineItemKey,
              quantity: 0
            })
          });

        } catch (error) {
          console.error('CartProgressBar: Failed to remove gift', error);
        }
    }

    updateProgress(cartTotal) {
      const messageEl = this.querySelector('.cart-progress__message');
      const fillEl = this.querySelector('.cart-progress__fill');
      const giftIconEl = this.querySelector('.cart-progress__icon--gift');
      const shippingLabelEl = this.querySelector('.cart-progress__label--shipping');
      const giftLabelEl = this.querySelector('.cart-progress__label--gift');
  
      let percent = (cartTotal / this.giftThreshold) * 100;
      if (percent > 100) percent = 100;
  
      if (fillEl) fillEl.style.width = `${percent}%`;
  
      if (cartTotal >= this.giftThreshold) {
        this.classList.add('is-gift-unlocked');
        
        if (messageEl) {
          messageEl.innerHTML = `You have unlocked a <strong>Free Gift</strong> — added at checkout`;
        }
        if (giftIconEl) giftIconEl.classList.add('is-active');
        if (shippingLabelEl) shippingLabelEl.classList.add('is-unlocked');
        if (giftLabelEl) {
          giftLabelEl.classList.add('is-unlocked');
          giftLabelEl.textContent = `FREE GIFT · ${this.formatMoney(this.giftThreshold)}`;
        }
      } 
      else if (cartTotal >= this.shippingThreshold) {
        this.classList.remove('is-gift-unlocked');
        
        const diff = this.giftThreshold - cartTotal;
        if (messageEl) {
          messageEl.innerHTML = `Add ${this.formatMoney(diff)} more and receive a <strong>Free Gift</strong>`;
        }
        if (giftIconEl) giftIconEl.classList.remove('is-active');
        if (shippingLabelEl) shippingLabelEl.classList.add('is-unlocked');
        if (giftLabelEl) {
          giftLabelEl.classList.remove('is-unlocked');
          giftLabelEl.textContent = `FREE GIFT · ${this.formatMoney(this.giftThreshold)}`;
        }
      } 

      else {
        this.classList.remove('is-gift-unlocked');
        
        const diff = this.shippingThreshold - cartTotal;
        if (messageEl) {
          messageEl.innerHTML = `Add ${this.formatMoney(diff)} more to get <strong>Free Shipping</strong>`;
        }
        if (giftIconEl) giftIconEl.classList.remove('is-active');
        if (shippingLabelEl) {
          shippingLabelEl.classList.remove('is-unlocked');
          shippingLabelEl.textContent = `FREE SHIPPING`;
        }
        if (giftLabelEl) {
          giftLabelEl.classList.remove('is-unlocked');
          giftLabelEl.textContent = `FREE GIFT · ${this.formatMoney(this.giftThreshold)}`;
        }
      }
    }
  
    render() {
      this.innerHTML = `
        <div class="cart-progress__card">
          <div class="cart-progress__message"></div>
          
          <div class="cart-progress__bar-wrapper">
            <div class="cart-progress__icon cart-progress__icon--shipping is-active">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.25 4.375H8.125V10H1.25V4.375Z" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" stroke="white"/>
                    <path d="M8.125 6.25H10.625L13.125 8.4375V10H8.125" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" stroke="white"/>
                    <path d="M4.875 10.9375C4.875 11.5588 4.37132 12.0625 3.75 12.0625C3.12868 12.0625 2.625 11.5588 2.625 10.9375C2.625 10.3162 3.12868 9.8125 3.75 9.8125C4.37132 9.8125 4.875 10.3162 4.875 10.9375Z" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" stroke="white"/>
                    <path d="M11.75 10.9375C11.75 11.5588 11.2463 12.0625 10.625 12.0625C10.0037 12.0625 9.5 11.5588 9.5 10.9375C9.5 10.3162 10.0037 9.8125 10.625 9.8125C11.2463 9.8125 11.75 10.3162 11.75 10.9375Z" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" stroke="white"/>
                </svg>
            </div>
  
            <div class="cart-progress__track">
              <div class="cart-progress__fill"></div>
            </div>
  
            <div class="cart-progress__icon cart-progress__icon--gift">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 12 20 22 4 22 4 12"></polyline>
                <rect x="2" y="7" width="20" height="5"></rect>
                <line x1="12" y1="22" x2="12" y2="7"></line>
                <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
              </svg>
            </div>
          </div>
  
          <div class="cart-progress__labels">
            <span class="cart-progress__label cart-progress__label--shipping">✓ FREE SHIPPING</span>
            <span class="cart-progress__label cart-progress__label--gift"></span>
          </div>
        </div>
      `;
    }
}
  
customElements.define('cart-progress-bar', CartProgressBar);